import { useState } from 'react';
import { AddressableViewLayout } from 'framework/ViewTypes';
import { bindCollection } from 'framework/ViewTypes/contentLayout';
import { useAuthorization } from 'framework/authorization';
import { getPositionFillRequestsTableConfig } from './positionFillRequestsTableConfig';
import usePositionFillRequestsCollection from './usePositionFillRequestsCollection';
import usePositionFillRequestsFilterBar from './usePositionFillRequestsFilterBar';
import { usePositionFillRequestsUrl } from '../routing';
import { POSITION_FILL_REQUEST_UPDATE, POSITION_FILL_REQUEST_CANCEL } from '../constants';
import type { PositionFillRequestListItem } from '../types';
import { EditPositionFillRequestDrawer, useCancelPositionFillRequestAction } from '../createupdate';
import { useRecruitmentPoolUrl } from 'domain/recruiting/recruitmentPool/routing';
import { useHighlightUrl } from 'framework/HighlightUrl';
import { ID_PFR_HIGHLIGHT } from 'domain/shared/positionFillRequest/constants';

const PositionFillRequestsListPage = () => {
  const { getSingleEntityUrl } = usePositionFillRequestsUrl();
  const { getHighlightById } = useHighlightUrl();
  const { getSingleEntityUrl: getRecruitmentPoolUrl } = useRecruitmentPoolUrl();
  const { isGranted } = useAuthorization();
  const [requestToEdit, setRequestToEdit] = useState<PositionFillRequestListItem>();
  const collection = usePositionFillRequestsCollection();
  const { searchProps, filterProps } = usePositionFillRequestsFilterBar(collection);
  const { cancel } = useCancelPositionFillRequestAction(collection.reload);

  const closeEditDrawer = () => setRequestToEdit(undefined);

  const binding = bindCollection(
    collection,
    getPositionFillRequestsTableConfig(
      collection.rows,
      id => getSingleEntityUrl(id),
      getRecruitmentPoolUrl,
      {
        highlighted: getHighlightById(ID_PFR_HIGHLIGHT),
        canActivate: isGranted(POSITION_FILL_REQUEST_UPDATE),
      },
      {
        canUpdate: isGranted(POSITION_FILL_REQUEST_UPDATE),
        canCancel: isGranted(POSITION_FILL_REQUEST_CANCEL),
        onEdit: setRequestToEdit,
        onCancel: request => cancel(request.id),
      },
    ),

    { searchProps, filterProps },
  );

  return (
    <AddressableViewLayout
      {...binding.pageProps}
      drawer={
        requestToEdit ? (
          <EditPositionFillRequestDrawer
            isOpen
            positionFillRequest={requestToEdit}
            onClose={closeEditDrawer}
            onSuccess={collection.reload}
          />
        ) : undefined
      }
    />
  );
};

export default PositionFillRequestsListPage;
